module.exports = __webpack_public_path__ + "img/中间.7ae40001.png";